import React from "react";
import ProjectsSection from "../components/MainSection/ProjectsSection";
const Projects = () => {
  return (
    <div>
      <ProjectsSection />
    </div>
  );
};

export default Projects;
